import axios from "axios";
import Errores from "../utils/Errores.js";

let getAreaCarreraInstitucionPorRegion = async function (params) {
    let url = API.INSTITUCIONES + "v1/instituciones/region_inst_carr_area"
    let response = await axios
        .get(url, {
            params
        })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            Errores.switchErrors(error);
            return null;
        });
    return response;
}

let getNombresCarrerasAutocompletado = async function (valor) {
    let url = API.INSTITUCIONES + "v1/instituciones/carreras/autocomplete?carrrera=" + valor;

    let response = await axios
        .get(url)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            Errores.switchErrors(error);
            return null;
        });
    return response;
}

let getNombreInstitutosAutocompletado = async function(valor){
    let url = API.INSTITUCIONES + "v1/instituciones/autocomplete?institucion=" + valor;

    let response = await axios
        .get(url)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            Errores.switchErrors(error);
            return null;
        });
    return response;
}

let getListadoUniversidadesPorRegion = async function (params) {
    let url = API.UNIVERSIDADES + "v1/instituciones/region_inst_carr_area"
    let response = await axios
        .get(url, {
            params
        })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            Errores.switchErrors(error);
            return null;
        });
    return response;
}

let getNombresCarrerasUniversitariasAutocompletado = async function (valor) {
    let url = API.UNIVERSIDADES + "v1/instituciones/carreras/autocomplete?carrrera=" + valor;

    let response = await axios
        .get(url)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            Errores.switchErrors(error);
            return null;
        });
    return response;
}

let getNombreUniversidadesAutocompletado = async function(valor){
    let url = API.UNIVERSIDADES + "v1/instituciones/autocomplete?institucion=" + valor;

    let response = await axios
        .get(url)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            Errores.switchErrors(error);
            return null;
        });
    return response;
}

export default {
    getAreaCarreraInstitucionPorRegion,
    getNombresCarrerasAutocompletado,
    getNombreInstitutosAutocompletado,
    getListadoUniversidadesPorRegion,
    getNombresCarrerasUniversitariasAutocompletado,
    getNombreUniversidadesAutocompletado
}


// WEBPACK FOOTER //
// ./src/services/ApiBuscador.js